import styled from "styled-components";
import SubpageLayout from "@components/SubpageLayout";
import useGetExpert from "@hooks/useGetExpert";
import ExpertSection from "@components/ExpertSection"; // Updated component
import mediaQuery from "@utils/mediaQuery";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 36px;

  ${mediaQuery("tablet")`
    align-self: flex-start;
    flex-wrap: wrap;
    gap: 48px;
  `}
`;

const LoadingMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  color: #505e79;
  font-size: var(--font-size-xl);
`;

const ErrorMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  color: #e53e3e;
  font-size: var(--font-size-xl);
  background-color: #fed7d7;
  border: 1px solid #feb2b2;
  border-radius: 8px;
  margin: 20px 0;
`;

const Expert = () => {
  const { experts, error, loading } = useGetExpert();

  // Combine north and south experts into a single object keyed by district name
  const allExperts = {
    ...experts?.north,
    ...experts?.south
  };

  if (loading) {
    return (
      <SubpageLayout
        title="Find an infection expert"
        subtitle="Find a local infection expert in your district. These contacts are for clinical staff. Patients and members of the public should contact their local primary health care provider for advice."
      >
        <LoadingMessage>Loading experts...</LoadingMessage>
      </SubpageLayout>
    );
  }

  if (error) {
    return (
      <SubpageLayout
        title="Find an infection expert"
        subtitle="Find a local infection expert in your district. These contacts are for clinical staff. Patients and members of the public should contact their local primary health care provider for advice."
      >
        <ErrorMessage>
          Unable to load expert information. Please try refreshing the page or contact support if the problem persists.
        </ErrorMessage>
      </SubpageLayout>
    );
  }

  return (
    <SubpageLayout
      title="Find an infection expert"
      subtitle="Find a local infection expert in your district. These contacts are for clinical staff. Patients and members of the public should contact their local primary health care provider for advice."
    >
      <Container>
        <ExpertSection 
          title="Find the Experts" 
          experts={allExperts}
        />
      </Container>
    </SubpageLayout>
  );
};

export default Expert;